<script setup lang="ts">
const colorMode = useColorMode()

const color = computed(() => colorMode.value === 'dark' ? 'white' : 'white')

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [
    { rel: 'icon', href: '/AzzadAssetLogo.svg' } // { rel: 'icon', href: '/favicon.ico' }
  ],
  htmlAttrs: {
    lang: 'en'
  }
})

const title = 'Azzad Client Portal'
const description = 'A professional client portal for Azzad Asset Management clients.'

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://azzadasset.com/wp-content/uploads/2023/07/Group-2-1.svg',
  twitterImage: 'https://azzadasset.com/wp-content/uploads/2023/07/Group-2-1.svg',
  twitterCard: 'summary_large_image'
})
</script>

<template>
  <UApp>
    <!-- Route-change progress rule, pinned to the top of the viewport. For a
         navigation whose data resolves quickly this is the ONLY loading
         affordance the user sees, so it is tuned to be honest rather than
         showy. `throttle` (Nuxt's 200ms default, pinned here so it is not
         tuned away by accident) holds the bar back entirely for navigations
         that finish sooner — the difference between "instant" and "briefly
         busy". `duration` is how long the bar takes to crawl toward 100%;
         raised above the default so it is still climbing when a typical page
         lands, rather than parking at the end and looking stalled. The gold
         glow ties it to the rest of the loading system. -->
    <NuxtLoadingIndicator
      color="linear-gradient(90deg, #C79900 0%, #614B00 155.7%)"
      error-color="#ef4444"
      :throttle="200"
      :duration="2500"
      class="shadow-[0_0_10px_rgba(199,153,0,0.55)]"
    />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
